export default "__VITE_ASSET__fn1x42ms__"